var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "what-creators-may-do", title: "What Creators May Do" } },
    [
      _c("template", { slot: "copy" }, [
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Copy, Change, and Share with Other Creators"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v("\n      may make copies of\n      "),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v("\n      and\n      "),
          _c("em", [_vm._v("Pro Software")]),
          _vm._v(", make changes to "),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v(", and share their changes with other "),
          _c("em", [_vm._v("Creators")]),
          _vm._v(".\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Embed in Projects"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v("\n      may\n      "),
          _c("strong", [_vm._v("Embed")]),
          _vm._v(" "),
          _c("em", [_vm._v("Pro Icons")]),
          _vm._v(", with or without changes, in "),
          _c("strong", [_vm._v("Projects")]),
          _vm._v(". For example:\n    "),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in documents.\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in designs and graphic art.\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in websites, e-books, and apps.\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Pass on Permission to Use Projects"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v(
            "\n      may pass on permission to others to copy, publicly display, and perform Projects that Embed Pro Icons, as part of those Projects. For example:\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in documents.\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in designs and graphic art.\n      "),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n        may\n        "),
            _c("em", [_vm._v("Embed Pro Icons")]),
            _vm._v("\n        in websites, e-books, and apps.\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Use Pro Software"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("em", [_vm._v("Creators")]),
          _vm._v("\n      may install and run\n      "),
          _c("em", [_vm._v("Pro Software")]),
          _vm._v("\n      for their own use, on their own computers.\n    "),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Exception for Limited License Customers to Acquired Rights"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The Company offers plans which include a perpetual license for use (as described herein), as well as plans which include limited licenses. The prices\n      and specifics of each plan, including the type of license granted, are described here:\n      "
          ),
          _c("a", { attrs: { href: "https://fontawesome.com/plans" } }, [
            _vm._v("https://fontawesome.com/plans"),
          ]),
          _vm._v(
            '\n      (the "Plans Page"). Customers who purchase plans with limited licenses are, herein, "Limited License Customers." Notwithstanding anything to the\n      contrary herein, the rights and permissions granted to Limited License Customers shall be limited according to the specific plan they purchase,\n      described on the Plans Page. Such limitations may include, but may not be limited to, the following:\n    '
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "certain Limited License Customers shall not have access to download Pro Icons,"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "certain Limited License Customers shall not have a perpetual license to use Pro Icons, and"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "certain Limited License Customers shall not be permitted to use Pro Icons after their subscription ends and this agreement is terminated."
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }